// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatchAccountsForm } from 'projects/appcloud-admin-portal/src/app/models/patch-accounts-form.model';
import { Account } from 'projects/internal/r1-component-library/src/lib/components/appcloud-login/appcloud-credentials/appcloud-credentials.model';
import { MatFormField, MatError, MatPrefix, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

/**
 * Displays a form to edit an individual App Cloud account.
 * Created with paginated App Cloud admin portal table of accounts in mind.
 */
@Component({
    selector: 'r1-edit-account',
    templateUrl: './edit-account.component.html',
    styleUrls: ['./edit-account.component.scss'],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatError,
        MatIcon,
        MatPrefix,
        MatLabel,
        MatInput,
        MatButton,
    ],
})
export class EditAccountComponent implements OnInit {
    readonly #formBuilder = inject(FormBuilder);

    @Input({ required: true }) account!: Account;
    @Output() patchAccountValue = new EventEmitter<Account>();
    patchAccountsFormGroup!: FormGroup<PatchAccountsForm>;

    ngOnInit() {
        this.patchAccountsFormGroup = this.#formBuilder.group(new PatchAccountsForm());
        this.patchAccountsFormGroup.patchValue({
            name: this.account.name,
            description: this.account.description,
            sfAccountId: this.account.sfAccountId,
        });
    }

    onSubmit(): void {
        if (this.patchAccountsFormGroup.valid) {
            const { name, description, sfAccountId } = this.patchAccountsFormGroup.getRawValue();
            this.patchAccountValue.emit({
                id: this.account.id,
                name: name,
                description: description,
                sfAccountId: sfAccountId,
            });
        }
    }

    public showError = (control: string, error: string) => {
        if (this.patchAccountsFormGroup) {
            const formControl = this.patchAccountsFormGroup.get(control) as FormControl;
            return formControl.hasError(error);
        }
    };
}
